/**
 * isAudioMutedScale — Early-out when mix scale is zero/invalid (FID-AUD-02).
 */

/**
 * @param {unknown} scale
 * @returns {boolean}
 */
export function isAudioMutedScale(scale) {
  const n = Number(scale);
  if (!Number.isFinite(n)) return true;
  return n <= 0;
}
